import React from "react";

import Context from "../../../context/Context";
import Icons from "../../util/Icons";
import ModalController from "../../common/Modal/ModalController";
import Topic from "../../../context/Topic";
import * as appLaunchUtil from "../../../aiim/util/appLaunchUtil";
import * as component from "../../util/component";
import * as shareUtil from "../InfoPanel/shareUtil";
import * as val from "../../../util/val";

const CSS = {
  main: "i-cfg-applaunch i-form-group i-section",
  section: "i-form-group i-section",
  formGroup: "i-form-group",
  formGroupHeader: "i-form-group-header",
  formGroupName: "i-form-group-name",
  required: "i--required",
  note: "i-note",
  issues: "i-issues",
  issue: "i-issue",
  actions: "i-actions i-text-right",
  primaryAction: "i-button",
  secondaryAction: "i-button i-button-clear",
  link: "i-link"
};

function actionMatches(action,source,subType) {
  return appLaunchUtil.actionMatches(action,source,subType);
}

function getSources() {
  return appLaunchUtil.getSources();
}

function makeValidActions(actions) {
  const valid = [];
  actions = appLaunchUtil.cloneActions(actions)
  actions.forEach(action => {
    let isEmpty = false;
    if (!val.isNonEmptyStr(action.label,true) && !val.isNonEmptyStr(action.url,true)) {
      if (action.layers.length === 0 && action.categories.length === 0) {
        isEmpty = true;
      } else if (action.layers.length === 1 && action.layers[0] === "*" &&
        action.categories.length === 1 && action.categories[0] === "*") {
        isEmpty = true;
      }
    }
    if (!isEmpty) {
      delete action.uiKey;
      valid.push(action);
    }
  });
  return valid;
}

function sourceMatches(action,source) {
  let matches = actionMatches(action,source);
  if (!matches && source.subTypes && source.subTypes.length) {
    matches = source.subTypes.some(subType => {
      return (action.categories.indexOf(subType.name) !== -1);
    });
  }
  return matches;
}

function subTypeMatches(action,source,subType) {
  return actionMatches(action,source,subType);
}

export default class AppLaunch extends React.Component {

  constructor(props) {
    super(props);
    this.state = component.newState({
      actions: this.cloneActionsFromConfig()
    });
  }

  addClicked = (evt) => {
    const actions = this.state.actions;
    const action = appLaunchUtil.newAction();
    this.setActionKey(action);
    actions.push(action);
    component.refresh(this);
  }

  cloneActionsFromConfig() {
    let actions = Context.instance.config.appLaunch.actions;
    actions = appLaunchUtil.cloneActions(actions)
    actions.forEach(action => {
      this.setActionKey(action);
    });
    return actions;
  }

  componentDidMount() {
    component.own(this,[
      Topic.subscribe(Topic.ViewsReloaded,params => {
        this.setState(state => {
          return {
            actions: this.cloneActionsFromConfig()
          };
        });
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  copyToClipboardClicked = (evt) => {
    const i18nAppLaunch = Context.instance.i18n.configurator.appLaunch;
    const actions = makeValidActions(this.state.actions);
    const v = JSON.stringify({"actions": actions});
    shareUtil.copyToClipboard(v,i18nAppLaunch.configurationCopied);
  }

  publishChange = () => {
    const actions = makeValidActions(this.state.actions);
    Context.instance.config.appLaunch.actions = actions;
    //console.log(JSON.stringify(actions,null,2));
    component.refresh(this);
    Topic.publish(Topic.AppLaunchURLsChanged,{});
  }

  remove = (action) => {
    const actions = this.state.actions;
    const idx = actions.indexOf(action);
    if (idx !== -1) {
      actions.splice(idx,1);
      this.publishChange();
    }
  }

  reorder = (action,dir) => {
    const actions = this.state.actions;
    const idx = actions.indexOf(action);
    if (dir === "moveUp" && idx > 0) {
      actions.splice(idx,1);
      actions.splice(idx - 1,0,action);
      this.publishChange();
    }
    if (dir === "moveDown" && idx < (actions.length - 1)) {
      actions.splice(idx,1);
      actions.splice(idx + 1,0,action);
      this.publishChange();
    }
  }

  render() {
    const i18n = Context.instance.i18n;
    const helpUrl = Context.instance.config.appLaunchHelpUrl;
    const actions = this.state.actions;

    let items = [];
    actions.forEach((action,i) => {
      let key = action.uiKey;
      let isFirst = (i === 0);
      let isLast = (i === (actions.length - 1));
      items.push(
        <li key={key}>
          <LaunchItem key={key} itemKey={key}
            action={action} isFirst={isFirst} isLast={isLast}
            onRemove={this.remove} onReorder={this.reorder}
            publishChange={this.publishChange}/>
        </li>
      );
    });

    let add = (
      <button type="button" className={"i-button i-margin-all-small"}
        onClick={this.addClicked}
        >{i18n.configurator.appLaunch.add}</button>
    );

    let copy = null;
    if (items.length > 0) {
      copy = (
        <button type="button" className={"i-button i-button-clear i-margin-all-small"}
          onClick={this.copyToClipboardClicked}
          >{i18n.configurator.appLaunch.copyToClipboard}</button>
      );
    }

    return (
      <div className={CSS.main}>
        <div key="hdr" className={CSS.formGroupHeader}>
          <span className={CSS.formGroupName}
            >{i18n.configurator.appLaunch.caption}</span>
        </div>
        <div key="prompt" className={"i--prompt"}
          >{i18n.configurator.appLaunch.prompt}</div>
        <div key="help" className={"i--help i-text-right"}>
          <a target="_blank" rel="noopener noreferrer" className={"i-link"}
            href={helpUrl}>{i18n.configurator.appLaunch.helpLink}</a>
        </div>
        <ul className="i-cfg-applaunch-items">
          {items}
        </ul>
        <div key="footer" className={"i--footer-actions i-text-right"}>
          {copy}{add}
        </div>
      </div>
    );
  }

  setActionKey(action) {
    action.uiKey = component.nextTmpId("i-cfg-applaunch-");
  }

}

class LaunchItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  getLayerNames(sources) {
    const i18nAppLaunch = Context.instance.i18n.configurator.appLaunch;
    if (sources.length === 0) {
      return i18nAppLaunch.item.noApplicableLayers;
    } else {
      const layerNames = [];
      const action = this.props.action;
      let nSourcesMatched = 0;
      sources.forEach(source => {
        if (actionMatches(action,source)) {
          layerNames.push(source.name);
          nSourcesMatched++;
        } else {
          if (source.subTypes && source.subTypes.length > 0) {
            source.subTypes.forEach(subType => {
              if (actionMatches(action,source,subType)) {
                layerNames.push(subType.name);
              }
            });
          }
        }
      });
      if (layerNames.length > 0) {
        if (nSourcesMatched === sources.length) {
          return i18nAppLaunch.item.allLayersSelected;
        } else {
          return layerNames.join(", ");
        }
      } else {
        return i18nAppLaunch.item.noLayersSelected;
      }
    }
  }

  moveDownClicked = (evt) => {
    if (this.props.onReorder) this.props.onReorder(this.props.action,"moveDown");
  }

  moveUpClicked = (evt) => {
    if (this.props.onReorder) this.props.onReorder(this.props.action,"moveUp");
  }

  onChangeLabel = (evt) => {
    let v = evt.target.value;
    if (typeof v === "string") v = v.trim();
    else v = null;
    this.props.action.label = v;
    this.publishChange();
  }

  onChangeUrl = (evt) => {
    let v = evt.target.value;
    if (typeof v === "string") v = v.trim();
    else v = null;
    this.props.action.url = v;
    this.publishChange();
  }

  onLayersSelected = () => {
    component.refresh(this);
    this.publishChange();
  }

  publishChange = () => {
    if (this.props.publishChange) this.props.publishChange();
  }

  removeClicked = (evt) => {
    const i18n = Context.instance.i18n;
    ModalController.showOkCancel({
      content: i18n.configurator.removePrompt,
      title: i18n.configurator.appLaunch.item.remove,
      className: "i-configurator-modal",
      onOk: () => this.props.onRemove(this.props.action)
    });
  }

  render() {
    const i18n = Context.instance.i18n;
    const i18nItem = i18n.configurator.appLaunch.item;
    const action = this.props.action;
    const key = this.props.itemKey;
    const btnCls = "i-button-clear-no-border i-font-brand-primary";

    let label = (
      <label key={key+"-label-label"} id={key+"-label-label"}
        htmlFor={key+"-label-input"}>
        <span className={CSS.formGroupName}
          >{i18nItem.label}</span>
        <input id={key+"-label-input"} type="text"
          defaultValue={action.label} onChange={this.onChangeLabel}/>
      </label>
    );

    let example = i18nItem.urlExamplePattern;
    let exampleUrl = "https://survey123.arcgis.com/share/myId?portalUrl=https://example.com/portal";
    example = example.replace("{url}",exampleUrl);
    let exampleNode = (
      <div key="urlExample" className={CSS.note}>{example}</div>
    );

    let url = (
      <label key={key+"-url-label"} id={key+"-url-label"}
        htmlFor={key+"-url-input"}>
        <span className={CSS.formGroupName}
          >{i18nItem.url}</span>
        <input id={key+"-url-input"} type="text"
          defaultValue={action.url} onChange={this.onChangeUrl}/>
        {exampleNode}
      </label>
    );

    const sources = getSources();
    let layerNames = this.getLayerNames(sources);
    let layers = (
      <div key={key+"-layers"}>
        <div key="hdr" className={"i--layer-header"}>
          <span className={CSS.formGroupName}
            >{i18nItem.layers}</span>
        </div>
        <div key="names" className={"i--layer-names"}>{layerNames}</div>
        <div key="sel" className={"i--actions i-text-right"}>
          <button type="button" className={btnCls}
            disabled={sources.length === 0}
            onClick={this.selectLayersClicked}
            >{i18nItem.selectLayers}</button>
        </div>
      </div>
    );

    let moveUp = (
      <button type="button" className={btnCls} onClick={this.moveUpClicked}
        disabled={this.props.isFirst} title={i18nItem.moveUp}
        >{Icons.arrowUp()}</button>
    );

    let moveDown = (
      <button type="button" className={btnCls} onClick={this.moveDownClicked}
        disabled={this.props.isLast} title={i18nItem.moveDown}
        >{Icons.arrowDown()}</button>
    );

    let remove = (
      <button type="button" className={btnCls} onClick={this.removeClicked}
        title={i18nItem.remove}>{Icons.X()}</button>
    );

    return (
      <div className={"i-cfg-applaunch-item"}>
        <div key="actions" className={"i--actions i-text-right"}>
          {moveUp}{moveDown}{remove}
        </div>
        {label}
        {url}
        {layers}
      </div>
    );
  }

  selectLayersClicked = (evt) => {
    const props = {
      action: this.props.action,
      onLayersSelected: this.onLayersSelected
    };
    SelectLayers.showModal(props);
  }

}

class SelectLayers extends React.Component {

  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  onChangeCheck = (item) => {
    const list = this.props.list;
    const checked = !!(item && item.checked);
    if (item && item.isAll) {
      list.forEach(item2 => {
        item2.checked = checked;
      });
    }

    // check/un-check all sub-types when parent is checked/un-checked
    if (item && item.subTypeItems && item.subTypeItems.length > 0) {
      item.subTypeItems.forEach(subTypeItem => {
        subTypeItem.checked = checked;
      });
    }

    // if (item && item.parentItem) {
    //   if (!checked) {
    //     // un-check the parent if a sub-type is unchecked
    //     item.parentItem.checked = false;
    //   } else {
    //     let subTypeItems = item.parentItem.subTypeItems;
    //     if (subTypeItems && subTypeItems.length > 0) {
    //       let all = subTypeItems.every(subTypeItem => {
    //         return subTypeItem.checked;
    //       });
    //       if (all) {
    //         // check the parent when sub-types are checked
    //         item.parentItem.checked = true;
    //       }
    //     }
    //   }
    // }

    component.refresh(this);
  }

  render() {
    const i18n = Context.instance.i18n;
    const i18nAppLaunch = i18n.configurator.appLaunch;
    const list = this.props.list;

    let numSelected = 0;
    const checkBoxes = [];
    list.forEach(item => {
      if (item.checked) numSelected++;
      checkBoxes.push(
        <li key={item.uiKey}>
          <CheckBox item={item} onChange={this.onChangeCheck}/>
        </li>
      );
    });

    const allItem = {
      name: i18nAppLaunch.selectLayers.all,
      checked: (numSelected > 0 && (numSelected === checkBoxes.length)),
      isAll: true
    }
    const all = (
      <CheckBox item={allItem} onChange={this.onChangeCheck}/>
    );

    return (
      <div className={"i--layers"}>
        {all}
        <ul>
          {checkBoxes}
        </ul>
      </div>
    );
  }

  static makeList(action) {
    const list = [];
    const sources = getSources();
    sources.forEach(source => {
      let itemChecked = sourceMatches(action,source);
      let item = {
        name: source.name,
        uiKey: source.name,
        fromCategoriesTable: !!source.fromCategoriesTable,
        checked: itemChecked,
        subTypeItems: []
      }
      list.push(item);
      if (source.subTypes && source.subTypes.length > 0) {
        source.subTypes.forEach(subType => {
          let subTypeChecked = subTypeMatches(action,source,subType);
          let subTypeItem = {
            name: subType.name,
            value: subType.name,
            uiKey: source.key+"/"+subType.name,
            fromCategoriesTable: !!source.fromCategoriesTable,
            checked: subTypeChecked,
            parentItem: item,
            isSubType: true
          }
          item.subTypeItems.push(subTypeItem);
          list.push(subTypeItem);;
        });
      }
    });
    return list;
  }

  static showModal(props) {
    const i18n = Context.instance.i18n;
    const i18nAppLaunch = i18n.configurator.appLaunch;
    const action = props.action;
    const list = SelectLayers.makeList(props.action);
    const modalController = new ModalController();
    const okClicked = () => {
      action.categories.length = 0;
      action.layers.length = 0;
      let num = 0;
      list.forEach(item => {
        if (item.checked) num++
      });
      if (num > 0 && num === list.length) {
        action.layers.push("*");
        action.categories.push("*");
      } else {
        list.forEach(item => {
          if (item.isSubType) return;
          if (item.checked) {
            if (item && item.subTypeItems && item.subTypeItems.length > 0) {
              let st = [];
              item.subTypeItems.forEach(subTypeItem => {
                if (subTypeItem.checked) st.push(subTypeItem.value);
              });
              if (st.length === 0 || st.length === item.subTypeItems.length) {
                action.categories.push(item.name);
              } else {
                st.forEach(v => action.categories.push(v));
              }
            } else {
              if (item.fromCategoriesTable) {
                action.categories.push(item.name);
              } else {
                action.layers.push(item.name);
              }
            }
          }
        });
      }
      if (props.onLayersSelected) props.onLayersSelected(action);
      modalController.close();
    };
    const cancelClicked = () => {
      modalController.close();
    }
    const content = (
      <div key="cfg-configurator-cancel-popup" className={CSS.formGroup}>
        <div className={"i-separated"}>
          <SelectLayers action={action} list={list}/>
        </div>
        <div key="actions" className={"i-actions i-text-right"}>
          <button key="cancel" type="button"
            className={"i-button i-button-clear i-margin-all-small"}
            onClick={cancelClicked}>{i18n.general.cancel}</button>
          <button key="ok" type="button"
            className={"i-button i-margin-all-small"}
            onClick={okClicked}>{i18n.general.ok}</button>
        </div>
      </div>
    );
    modalController.show(content,
      i18nAppLaunch.selectLayers.caption,"i-configurator-modal i-cfg-applaunch");
  }

}

class CheckBox extends React.Component {

  constructor(props) {
    super(props);
    this.state = component.newState({
      componentId: component.nextId()
    });
  }

  onChange = (evt) => {
    const checked = evt.target.checked;
    this.props.item.checked = checked;
    component.refresh(this);
    if (this.props.onChange) this.props.onChange(this.props.item);
  }

  render() {
    const id = this.state.componentId;
    const item = this.props.item;
    const isSubType = !!item.isSubType;
    let cls = "i-checkbox-row";
    if (item.isAll) cls += " i--all";
    if (isSubType) {
      cls += " i--indent";
      if (!item.parentItem.checked) return null;
    }
    return (
      <div className={cls}>
        <input id={id+"-input"} type="checkbox" checked={item.checked}
          onChange={this.onChange}/>
        <label htmlFor={id+"-input"}>{item.name}</label>
      </div>
    );
  }

}
